export default __webpack_public_path__ + "static/media/forca-krans.ceb397dd.svg";